import PagedResult from "../interfaces/pagedResult";
import useOrdinationStore from "../store/ordinationStore";

const PageSelector = (paged: PagedResult<any>) => {
  const page = useOrdinationStore((state) => state.page);
  const setPage = useOrdinationStore((state) => state.setPage);

  const totalPages = paged?.totalPages ?? 0;
  const pages = [];

  if (totalPages <= 1) return null;

  for (let i = 0; i < totalPages; i++) {
    pages.push(
      <li key={i} className="page-item">
        <button onClick={() => setPage(i)} className="page-link">
          {i + 1}
        </button>
      </li>
    );
  }

  return (
    <nav aria-label="Pagination">
      <ul className="pagination">
        <li className={`page-item ${page === 0 ? "disabled" : ""}`}>
          <button onClick={() => setPage(page - 1)} className="page-link">
            Previous
          </button>
        </li>
        {pages}
        <li
          className={`page-item ${page === totalPages - 1 ? "disabled" : ""}`}
        >
          <button onClick={() => setPage(page + 1)} className="page-link">
            Next
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default PageSelector;
